import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DetailRepository from "../Repositories/DetailRepository";

class DetailBloc {
  listChannel = new Subject();
  exportExcelChannel = new Subject();
  exportRekapChannel = new Subject();
  workUnitChannel = new Subject();
  repository = new DetailRepository();
  exportNewChannel = new Subject();
  fetchexportTemplatePetaJabatanChannel = new Subject() 
  fetchimportDataPetaJabatanChannel = new Subject()
  fetchcheckmutasipegawaiChannel = new Subject();

  constructor() {
    this.listChannel.next({ status: apiResponse.INITIAL });
    this.exportRekapChannel.next({ status: apiResponse.INITIAL });
    this.exportExcelChannel.next({ status: apiResponse.INITIAL });
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.exportNewChannel.next({ status: apiResponse.INITIAL });
    this.fetchexportTemplatePetaJabatanChannel.next({ status: apiResponse.INITIAL });
    this.fetchimportDataPetaJabatanChannel.next({ status: apiResponse.INITIAL });
    this.fetchcheckmutasipegawaiChannel.next({status: apiResponse.INITIAL})
  }

  fetchList = async (query) => {
    try {
      this.listChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchList(query)
        .then((result) => {
          this.listChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchExportExcel = async (query) => {
    try {
      this.exportExcelChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExportExcel(query)
        .then((result) => {
          this.exportExcelChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportExcelChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchExportRekap = async (query) => {
    try {
      this.exportRekapChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExportRekap(query)
        .then((result) => {
          this.exportRekapChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportRekapChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchWorkUnit = async (query) => {
    try {
      this.workUnitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchWorkUnit(query)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchExportNew = async (query) => {
    try {
      this.exportNewChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExportNew(query)
        .then((result) => {
          this.exportNewChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportNewChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchexportTemplatePetaJabatan = async (query) => {
    try {
      this.fetchexportTemplatePetaJabatanChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchexportTemplatePetaJabatan(query)
        .then((result) => {
          this.fetchexportTemplatePetaJabatanChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.fetchexportTemplatePetaJabatanChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchimportDataPetaJabatan = async (query) => {
    try {
      this.fetchimportDataPetaJabatanChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchimportDataPetaJabatan(query)
        .then((result) => {
          this.fetchimportDataPetaJabatanChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.fetchimportDataPetaJabatanChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  fetchcheckmutasipegawai = async (query) => {
        try {
            this.fetchcheckmutasipegawaiChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchcheckmutasipegawai(query).then((result) => {
                this.fetchcheckmutasipegawaiChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.fetchcheckmutasipegawaiChannel.next({status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
}

export default DetailBloc;